<template>
  <div class="order-change-records-list">
    <Spin v-if="loading"></Spin>
    <div v-else>
      <div v-for="r in changeRecordsList" :key="r.id">
        <div class="header">
          <h3>{{ moment(r.created_at).format('YYYY-MM-DD') }}</h3>
          <p>
            <span style="background: gray; padding: 4px 2px; border-radius: 8px; color: #fff;">{{ r.change_reasoning }}&nbsp;</span>
            <span v-show="r.sub_order_number" style="background: red; padding: 4px 2px; border-radius: 8px; color: #fff;">{{ r.sub_order_number }}&nbsp;</span>
            {{ r.description }},
            {{ r.invoice_number }},
            <b>{{ intlCurrencyNumber(r.currency, r.amount, 2, 2) }}</b>,
            <span v-if="!!r.quote">{{ $t('order.order_change_record_quote_created') }}</span>
            <span :class="{ 'warning' : r.status === 'open', 'success' : r.status === 'approved', 'error' : r.status === 'invalided' }" v-else>
              {{ $t(`order.change_status_${r.status}`) }}
            </span>&nbsp;
            <a @click="handleClicked(r)"><Icon type="md-create" />{{ $t('view') }}</a>
          </p>
        </div>
        <div>
          <vxe-table class="margin-top-20" :data="r.items.filter(i => i.referenced_type !== 'fee_type')" size="mini" show-footer border>
            <vxe-table-column type="seq" align="center" width="30"></vxe-table-column>
            <vxe-table-column :title="$t('order.product_number')" width="120">
              <template #default="{ row }"><span v-if="row.referenced.part_identity">{{ row.referenced.part_identity.part_number }}</span><span class="error" v-else>{{ $t('order.missing_data_error') }}</span></template>
            </vxe-table-column>
            <vxe-table-column :title="$t('order.product')" min-width="200">
              <template #default="{ row }">
                <div  v-if="row.referenced_type === 'product'">
                  <div>
                    <span v-if="row.product.english_name">{{ order.accounting_company === 'NexGroup Inc.' ? row.product.english_name : row.product.product_name }} </span>
                    <span v-else>{{row.product.product_name}}</span>
                  </div>
                </div>
                <div v-else-if="row.referenced_type === 'manufacturer_part'">
                  <span>{{ row.referenced.name }}</span>
                </div>
                <div v-else-if="row.referenced_type === 'fee_type'">
                  <span>{{ row.referenced.title }}</span>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column field="quantity" :title="$t('order.quantity')" align="right" width="80"></vxe-table-column>
            <vxe-table-column field="unit_price" :title="$t('order.unit_price')" align="right" width="120">
              <template #default="{ row }">{{ intlCurrencyNumber(row.currency, row.unit_price, 2, 2) }}</template>
            </vxe-table-column>
            <vxe-table-column field="unit_cost" :title="$t('order.unit_cost')" align="right" width="120">
              <template #default="{ row }">{{ intlCurrencyNumber(row.currency, row.unit_cost, 2, 2) }}</template>
            </vxe-table-column>
            <vxe-table-column field="margin" :title="$t('order.margin')" align="right" width="120">
              <template #default="{ row }">{{ intlCurrencyNumber(row.currency, row.margin, 2, 2) }}</template>
            </vxe-table-column>
            <vxe-table-column field="subtotal" :title="$t('order.subtotal')" align="right" width="120">
              <template #default="{ row }">{{ intlCurrencyNumber(row.currency, row.unit_price * row.quantity, 2, 2) }}</template>
            </vxe-table-column>
            <vxe-table-column field="delivery_date" :title="$t('order.delivery_date')" width="100">
              <template #default="{ row }">{{ row.delivery_date ? moment(row.delivery_date).format('YYYY-MM-DD') : '' }} <span v-if="!row.delivery_date" class="error">{{ $t('order.missing_data_error') }}</span></template>
            </vxe-table-column>
          </vxe-table>

          <vxe-table class="margin-top-20" :data="r.items.filter(i => i.referenced_type === 'fee_type')" size="mini" border>
            <vxe-table-column type="seq" align="center" width="30"></vxe-table-column>
            <vxe-table-column field="description" :title="$t('description')" min-width="220"></vxe-table-column>
            <vxe-table-column field="quantity" :title="$t('quantity')" width="120" align="right"></vxe-table-column>
            <vxe-table-column field="unit_price" :title="$t('order.price')" width="160" align="right">
              <template #default="{ row }">{{ intlCurrencyNumber(row.currency, row.unit_price, 2, 2) }}</template>
            </vxe-table-column>
            <vxe-table-column :title="$t('order.subtotal')" width="120" align="right">
              <template #default="{ row }">{{ intlCurrencyNumber(row.currency, row.unit_price * row.quantity, 2, 2) }}</template>
            </vxe-table-column>
            <vxe-table-column field="currency" :title="$t('currency')" width="80" align="center"></vxe-table-column>
            <vxe-table-column :title="$t('order.fee_type')" width="320">
              <template #default="{ row }">
                <div>{{ row.referenced.title }}</div>
                <span style="color: #808695; font-size: 90%;">{{ row.referenced.description }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </div>
    </div>
    <p v-if="changeRecordsList.length === 0">{{ $t('empty_data') }}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { intlCurrencyNumber } from '@/libs/util'
import moment from 'moment'
export default {
  name: "OrderChangeRecords",
  props: {
    orderId: {
      type: Number,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      changeRecordsList: []
    }
  },
  mounted () {
    this.loadChangeRecords()
  },
  methods: {
    moment,
    intlCurrencyNumber,
    ...mapActions(['getOrderChangeRecords', 'getOrderChangeRecordItems']),
    loadChangeRecords () {
      this.loading = true
      this.getOrderChangeRecords(this.orderId)
        .then(resp => {
          this.changeRecordsList = resp.data
        }).finally(() => {
          this.loading = false
        })
    },
    handleClicked (record) {
      this.$emit('on-clicked', record)
    }
  }
}
</script>

<style lang="less">
.order-change-record--unpublished {
  color: #808695;
}
.order-change-records-list .is--empty {
  display: none;
}
</style>
